// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__xIWDq","header":"PatientQuestionnaire_header__2y0FJ","info":"PatientQuestionnaire_info__15xXD"};